import React from 'react';
import { Button } from 'reactstrap';
import __ from 'utils/i18n';

export const BulkActionsWidget = ({ disabled, onAction }) => (
  <div className="d-flex align-items-center">
    <Button
      className="buttom-radius action__create-item d-flex align-items-center mr-2"
      onClick={() => onAction('pause')}
      disabled={disabled}
    >
      <i className="mdi mdi-pause mr-1" />
      {__('dashboard.sections.recurringPayments.subscribers.bulk.pause.label')}
    </Button>
    <Button
      className="buttom-radius action__create-item d-flex align-items-center mr-2"
      onClick={() => onAction('reactivate')}
      disabled={disabled}
    >
      <i className="mdi mdi-refresh mr-1" />
      {__('dashboard.sections.recurringPayments.subscribers.bulk.reactivate.label')}
    </Button>
    <Button
      className="buttom-radius action__create-item d-flex align-items-center"
      onClick={() => onAction('cancel')}
      disabled={disabled}
    >
      <i className="mdi mdi-cancel mr-1" />
      {__('dashboard.sections.recurringPayments.subscribers.bulk.cancel.label')}
    </Button>
  </div>
);
